<template>
    <div>
        <div>
            <Button label="Go to Blocks" @click="goBack" />
            <div class="text-center">
                <h4>{{ block?.name }}</h4>
                <strong> <i>Note: You can add formula to only containers.</i></strong>
            </div>
        </div>
        <div class="main-container">
            <div class="col-12 md:col-7">
                <div class="form-container">
                    <!-- loads component only after block id has been set to avoid any issues -->
                    <box-builder-form class="mt-3" v-if="selectedBlockId" />
                </div>
            </div>
            <div class="card col-12 md:col-5">
                <Accordion :activeIndex="0">
                    <AccordionTab header="Elements Hierarchy in Block"> <box-builder-element-details /></AccordionTab>
                </Accordion>
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useRoute, useRouter } from 'vue-router';
import { useBlockStore } from '../../products/pha/modules/block/store';
import BoxBuilderForm from '@/components/box-builder/BoxBuilderForm.vue';
import BoxBuilderElementDetails from '../../components/box-builder/BoxBuilderElementDetails.vue';

import useBoxBuilderComposable from '@/composables/BoxBuilderComposable';

const route = useRoute();
const router = useRouter();
const blockStore = useBlockStore();
const { block } = storeToRefs(useBlockStore());
const { setBlockId, selectedBlockId } = useBoxBuilderComposable();

onMounted(async () => {
    await setBlockId(route.params.blockId);
    await blockStore.fetchBlockDetails('Company', route.params.blockId);
});

const goBack = () => {
    router.push({ name: 'Blocks' });
};
</script>

<style>
/* transition css starts*/
.v-enter-active,
.v-leave-active {
    transition: opacity 0.8s ease;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
/* transition css ends */

.main-container {
    display: flex;
    flex-flow: row wrap;
}

.btns-container {
    display: flex;
    flex-flow: row;
    justify-content: center;
}

.btns-container Button {
    margin: 0.75rem;
}
</style>
